module.exports = __webpack_public_path__ + "img/lexu.2d5ed227.jpg";